import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  MenuItem,
  ListItemIcon,
  Button,
  IconButton,
  Grid,
  TextField,
  InputAdornment,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  InputLabel,
  Alert,
  Modal,
  Snackbar,
  useMediaQuery,
  Portal,
  Tooltip
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import "../../App.css";
import Drawer from "@mui/material/Drawer";
import { Badge } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import trendAdsIcon from "../../images/trendadsIcon.png";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { fetchAdminDetails, fetchDetailsByRole } from "../../slices/userSlice";
import { loginStatus } from "../../slices/loginSlice";
import baseUrl from "../../slices/baseUrl";
import DashboardIcon from "../../images/icons/dashboardIcon.png";
import AdvListIcon from "../../images/icons/advListIcon.png";
import AdvListIconDark from "../../images/icons/advListIconDark.png";
import AdApprovalIcon from "../../images/icons/adApprovalListIcon.png";
import AdApprovalIconDark from "../../images/icons/adAprovalListIconDark.png";
import AccessMntIcon from "../../images/icons/accessmntIcon.png";
import AccessMntIconDark from "../../images/icons/accessmntIconDark.png";
import ClaimRequestsDark from "../../images/icons/claimRequestsDark.png";
import ClaimRequests from "../../images/icons/claimRequests.png";
import SupportIcon from "../../images/icons/supportIcon.png";
import ViewersListIcon from "../../images/icons/viewersListIcon.png";
import refundRequestWhite from "../../images/icons/refundRequestWhite.png";
import refundRequestDark from "../../images/icons/refundRequestDark.png";
import ViewersListIconDark from "../../images/icons/viewersListIconDark.png";
import ProfileImage from "../../images/icons/profileImage.png";
import EditIcon from "../../images/icons/edit.png";
import DashboardIconDark from "../../images/icons/dashboardIconDark.png";
import SupportIconDark from "../../images/icons/supportIconDark.png";
import trendAdsLogo from "../../images/trendads-1.png";
import ThemeToggle from "./ThemeToggle";
import BellIcon from "../../images/icons/bellIcon.png";
import Notifications from "./Notifications/Notifications";
import { useThemeContext } from './ThemeContext';
import { getNotificationCountByEmailId } from "../../slices/notificationSlice";

const Sidebar = ({ activeButton }) => {
  let admMenuSelected = sessionStorage?.getItem("admMenuSelected");
  const sText = process.env.REACT_APP_SECRET;
  const dispatch = useDispatch();
  const userId = sessionStorage?.getItem("userId");
  const role = sessionStorage?.getItem("role");
  const user = useSelector((state) => state?.user?.user);
  const roleWiseDetails = useSelector((state) => state?.user?.roleWiseDetails);
  const isLoggedIn = useSelector((state) => state?.emailLogin?.loginStatus);
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 600);
  const [selected, setSelected] = useState(null);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const [profileOpen, setProfileOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [open, setOpen] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);
  const [errorMsgForgotPwd, setErrorMsgForgotPwd] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otpValue, setOtpValue] = useState("");
  const [newEmailValue, setNewEmailValue] = useState("");
  const [logoutOpen, setLogoutOpen] = useState(false);
  const [emailConfirmOpen, setEmailConfirmOpen] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [newLocation, setNewLocation] = useState("");
  const [isMobile, setIsMobile] = useState(false); // Mobile view state
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // profile image
  const [editMode, setEditMode] = useState(false);
  const [removeMode, setRemoveMode] = useState(false);
  const [changeMode, setChangeMode] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [sideBarMenu, setSideBarMenu] = useState([]);

  // Mobile Header Logic
  const notificationBoxRef = React.useRef(null);
  // const [isNotificationOpen, setIsNotificationOpen] = useState(false); // Using isOpen for Sidebar logic might conflict?
  // Sidebar already has 'open' state (line 84: const [open, setOpen] = useState(false); for password dialog)
  // And 'emailOpen', 'logoutOpen'.
  // 'isSidebarOpen' (line 101).
  // So 'isOpen' (line 28 in Topbar) needs a unique name in Sidebar.
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [displayNotificationCount, setDisplayNotificationCount] = useState(0);

  const notificationCount = useSelector((state) => state?.notification?.notificationCount);
  const sessionEmail = sessionStorage?.getItem("email");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isNotificationOpen && notificationBoxRef.current && !notificationBoxRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isNotificationOpen]);

  const toggleNotificationPopup = () => {
    setIsNotificationOpen((prevState) => !prevState);
  };


  useEffect(() => {
    if (userId > 0 && sessionEmail) {
      dispatch(getNotificationCountByEmailId(sessionEmail));
    }
  }, [userId, sessionEmail, dispatch]);

  useEffect(() => {
    if (notificationCount > 0) {
      setDisplayNotificationCount(notificationCount);
    }
  }, [notificationCount]);

  useEffect(() => {
    setDisplayNotificationCount(0);
  }, [isNotificationOpen]);

  const location = useLocation();
  // const isActive = location.pathname === to;
  // const isHovered = hoveredIcon === title;

  const menuItems = [
    {
      label: "Dashboard",
      srno: 1,
      to: "dashboard",
      icon: DashboardIcon,
      darkIcon: DashboardIconDark,
    },
    {
      label: "Viewers List",
      srno: 2,
      to: "viewersList",
      icon: ViewersListIcon,
      darkIcon: ViewersListIconDark,
    },
    {
      label: "Advertisers List",
      srno: 3,
      to: "advertiserslist",
      icon: AdvListIcon,
      darkIcon: AdvListIconDark,
    },
    {
      label: "Ad Approval List",
      srno: 4,
      to: "adApprovallist",
      icon: AdApprovalIcon,
      darkIcon: AdApprovalIconDark,
    },
    {
      label: "Access Management",
      srno: 5,
      to: "accessmanagement",
      icon: AccessMntIcon,
      darkIcon: AccessMntIconDark,
    },
    // {
    //     label: 'Redeem Requests',
    //     srno: 6,
    //     to: 'requests/redeemrequests',
    //     icon: ClaimRequests,
    //     darkIcon: ClaimRequestsDark
    // },
    {
      label: "Refund Requests",
      srno: 7,
      to: "requests/refundrequests",
      icon: refundRequestWhite,
      darkIcon: refundRequestDark,
    },
    {
      label: "Support",
      srno: 8,
      to: "support",
      icon: SupportIcon,
      darkIcon: SupportIconDark,
    },
    {
      label: "Tasks",
      srno: 9,
      to: "tasks",
      icon: ClaimRequests,
      darkIcon: ClaimRequestsDark,
    },
  ];

  useEffect(() => {
    admMenuSelected = sessionStorage?.getItem("admMenuSelected");
    if (admMenuSelected) {
      setSelected(admMenuSelected);
    } else {
      setSelected("Dashboard");
      sessionStorage.setItem("admMenuSelected", "Dashboard");
    }

    const handleResize = () => {
      const width = window.innerWidth;

      setIsMobile(width < 600);
      setIsCollapsed(width >= 600 && width < 900);

      if (width < 600) {
        setIsSidebarOpen(false); // Hide sidebar initially on mobile
      }
    };

    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (userId) {
      dispatch(fetchAdminDetails(userId));
      fetchProfilePicture(userId);
    }
  }, [userId]);

  useEffect(() => {
    role && dispatch(fetchDetailsByRole(role));
  }, [role]);

  useEffect(() => {
    if (user) {
      setWalletAddress(user?.walletAddress);
      setEmail(user?.email);
      setUserRole(user?.role);
    }
  }, [user]);

  useEffect(() => {
    if (location.pathname.includes("adApprovallist")) {
      sessionStorage.setItem("admMenuSelected", "Ad Approval List");
      setSelected("Ad Approval List");
      setNewLocation(location.pathname);
    }
    if (location.pathname.includes("viewersList")) {
      sessionStorage.setItem("admMenuSelected", "Viewers List");
      setSelected("Viewers List");
      setNewLocation(location.pathname);
    }
    if (location.pathname.includes("support")) {
      sessionStorage.setItem("admMenuSelected", "Support");
      setSelected("Support");
      setNewLocation(location.pathname);
    }
    if (location.pathname.includes("checkAd")) {
      sessionStorage.setItem("admMenuSelected", "Ad Approval List");
      setSelected("Ad Approval List");
      setNewLocation(location.pathname);
    }
    if (location.pathname.includes("refundrequests")) {
      sessionStorage.setItem("admMenuSelected", "Refund Requests");
      setSelected("Refund Requests");
      setNewLocation(location.pathname);
    }
    if (location.pathname.includes("tasks")) {
      sessionStorage.setItem("admMenuSelected", "Tasks");
      setSelected("Tasks");
      setNewLocation(location.pathname);
    }
  }, [location]);

  useEffect(() => {
    let newSideBarMenu = [];
    if (roleWiseDetails?.access) {
      roleWiseDetails?.access?.forEach((item) => {
        menuItems?.map((menuItem) => {
          if (menuItem?.srno === item) {
            newSideBarMenu.push(menuItem);
          }
        });
      });
    } else {
      // Bypass: Show all menu items if no specific access is defined
      newSideBarMenu = menuItems;
    }

    // Ensure "Tasks" is always visible if not already included (srno 9)
    if (!newSideBarMenu.find(item => item.srno === 9)) {
      const taskItem = menuItems.find(item => item.srno === 9);
      if (taskItem) newSideBarMenu.push(taskItem);
    }

    setSideBarMenu(newSideBarMenu);
  }, [roleWiseDetails]);

  const handleProfileEditClick = () => {
    setEditMode(true);
  };
  const handleProfileEditClickCancel = () => {
    setEditMode(false);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const handleImageUpload = async () => {
    if (selectedImage === null) {
      setSnackbarMessage("Select file to upload");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } else {
      try {
        const formData = new FormData();
        formData.append("media", selectedImage);
        const response = await axios.put(
          `${baseUrl}/users/updateProfilePic/${userId}`,
          formData
        );
        if (response.status === 200) {
          setSnackbarMessage(response?.data);
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          setEditMode(false);
          setChangeMode(false);
          fetchProfilePicture(userId);
        } else {
          setSnackbarMessage(response?.data);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        setSnackbarMessage(error?.response?.data?.developermsg);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
      setEditMode(false);
    }
  };

  const expand = () => {
    setIsCollapsed((prevState) => !prevState);
  };

  const handleMenuClick = () => {
    setIsSidebarOpen(true);
  };
  const handleCloseClick = () => {
    setIsSidebarOpen(false);
  };

  // get profile picture
  const fetchProfilePicture = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/users/getProfileOfAdvertiser/${userId}`,
        {
          method: "GET",
        }
      );

      if (response?.ok) {
        const imageData = await response?.blob();
        const imageUrl = URL.createObjectURL(imageData);

        setProfilePicture(imageUrl);
      } else {
        return;
      }
    } catch (error) {
      setSnackbarMessage("Error fetching profile picture:");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const Item = ({ title, to, icon, darkIcon, selected, setSelected }) => {
    const isActive = selected === title;
    return (
      <Link to={to} style={{ textDecoration: "none", display: 'block', padding: '4px 12px' }}>
        <MenuItem
          selected={isActive}
          onClick={() => {
            sessionStorage.setItem("admMenuSelected", title);
            setSelected(title);
            if (isMobile) setIsSidebarOpen(false);
          }}
          sx={{
            minHeight: "44px",
            borderRadius: "12px",
            mb: 0.5,
            transition: 'all 0.2s ease',
            backgroundColor: isActive ? 'primary.main' : 'transparent',
            color: isActive ? 'common.black' : 'text.secondary',
            '&:hover': {
              backgroundColor: isActive ? 'primary.dark' : 'rgba(255, 255, 255, 0.05)',
              color: isActive ? 'common.black' : 'text.primary',
              transform: 'translateX(4px)',
            },
            '&.Mui-selected': {
              backgroundColor: 'primary.main',
              color: 'common.black',
              '&:hover': { backgroundColor: 'primary.dark' },
            },
          }}
        >
          <ListItemIcon
            sx={{
              color: 'inherit',
              minWidth: isCollapsed ? 0 : 40,
              justifyContent: 'center',
            }}
          >
            <img
              src={theme.palette.mode === 'dark' ? icon : (darkIcon || icon)}
              alt={title}
              style={{
                height: "20px",
                width: "20px",
                filter: isActive ? 'brightness(0)' : (theme.palette.mode === 'light' ? 'invert(1)' : 'none'),
                opacity: isActive ? 1 : 0.7
              }}
            />
          </ListItemIcon>
          {!isCollapsed && (
            <Typography variant="body2" sx={{ fontWeight: isActive ? 700 : 500 }}>
              {title}
            </Typography>
          )}
        </MenuItem>
      </Link>
    );
  };

  const SidebarContent = ({
    isMobileDrawer = false
  }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { mode } = useThemeContext();

    return (
      <Box
        className="glass-vanguard animate-fade-in"
        sx={{
          height: "100vh",
          width: "100%",
          borderRadius: isMobile || isMobileDrawer ? "0" : "0 24px 24px 0",
          display: "flex",
          flexDirection: "column",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          overflow: "hidden",
          position: 'relative',
          zIndex: 10,
          background: theme.palette.mode === 'dark'
            ? "rgba(10, 10, 10, 0.7) !important"
            : "rgba(255, 255, 255, 0.7) !important",
          backdropFilter: "blur(24px) saturate(180%)",
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        {/* Brand Section */}
        <Box sx={{ p: 3, mb: 1, display: 'flex', alignItems: 'center', justifyContent: isCollapsed && !isMobileDrawer ? 'center' : 'space-between' }}>
          {(!isCollapsed || isMobileDrawer) && (
            <img
              src={trendAdsLogo}
              alt="Logo"
              style={{ height: '32px', cursor: 'pointer', filter: theme.palette.mode === 'dark' ? 'drop-shadow(0 0 8px rgba(34, 211, 238, 0.3))' : 'none' }}
              onClick={() => {
                navigate('dashboard');
                if (isMobile) setIsSidebarOpen(false);
              }}
            />
          )}
          {!isMobile && (
            <IconButton onClick={() => setIsCollapsed(!isCollapsed)} sx={{ color: 'primary.main' }}>
              {isCollapsed ? <MenuOpenIcon /> : <MenuIcon />}
            </IconButton>
          )}
          {isMobileDrawer && (
            <IconButton onClick={() => setIsSidebarOpen(false)} sx={{ color: 'primary.main' }}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>

        {/* Profile Section */}
        <Box
          sx={{ px: 2, mb: 3, cursor: 'pointer', '&:hover': { opacity: 0.8 } }}
          onClick={() => {
            setProfileOpen(true);
            if (isMobile) setIsSidebarOpen(false);
          }}
        >
          <Box
            sx={{
              p: 1.5, borderRadius: '16px',
              background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)',
              display: 'flex', alignItems: 'center', gap: 2,
              justifyContent: isCollapsed && !isMobileDrawer ? 'center' : 'flex-start'
            }}
          >
            <Avatar
              src={profilePicture || ProfileImage}
              sx={{ width: 36, height: 36, border: `2px solid ${theme.palette.primary.main}` }}
            />
            {(!isCollapsed || isMobileDrawer) && (
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.primary', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {email?.split('@')[0]}
                </Typography>
                <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 600 }}>
                  {userRole} Admin
                </Typography>
              </Box>
            )}
          </Box>
        </Box>

        {/* Navigation Section */}
        <Box sx={{ flexGrow: 1, px: 2, overflowY: 'auto', '&::-webkit-scrollbar': { display: 'none' } }}>
          {sideBarMenu.map((item) => (
            <Item
              key={item.label}
              title={item.label}
              to={item.to}
              icon={item.icon}
              darkIcon={item.darkIcon}
              selected={selected}
              setSelected={setSelected}
              isMobile={isMobile}
              setIsSidebarOpen={setIsSidebarOpen}
            />
          ))}
        </Box>

        {/* Bottom Actions */}
        <Box sx={{ p: 2, mt: 'auto', borderTop: `1px solid ${theme.palette.divider}` }}>
          <MenuItem
            onClick={() => setLogoutOpen(true)}
            sx={{ borderRadius: '12px', color: 'error.main', '&:hover': { backgroundColor: 'rgba(239, 68, 68, 0.1)' } }}
          >
            <ListItemIcon sx={{ color: 'inherit', minWidth: isCollapsed && !isMobileDrawer ? 0 : 40, justifyContent: 'center' }}>
              <LogoutOutlinedIcon fontSize="small" />
            </ListItemIcon>
            {(!isCollapsed || isMobileDrawer) && <Typography variant="body2" sx={{ fontWeight: 600 }}>Sign Out</Typography>}
          </MenuItem>
        </Box>
      </Box>
    );
  };

  function ProfileWithUsername({ profileImageSrc, email }) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingLeft="4px"
      >
        {profilePicture ? (
          <img
            src={profilePicture}
            alt="Profile"
            style={{
              width: "33px",
              height: "33px",
              border: `1.5px solid ${theme.palette.primary.main}`,
              borderRadius: "50%",
            }}
          />
        ) : (
          <Avatar alt="Profile Picture" src={ProfileImage} />
        )}
        {!isCollapsed && (
          <Box marginLeft={0.5}>
            <Typography
              variant="body2"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "130px",
              }}
            >
              {email}
            </Typography>
            <Typography
              variant="subtitle2"
              fontSize={11}
              color={theme.palette.primary.main}
            >
              {userRole} Panel
            </Typography>
          </Box>
        )}
      </Box>
    );
  }

  const HandleOpenProfile = () => {
    setProfileOpen(true);
  };
  const handleCloseNav = () => {
    setProfileOpen(false);
    setEditMode(false);
  };
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  // profile styles
  const profileContainerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "1.5rem",
  };

  const avatarStyle = {
    width: isMobile ? "90px" : "100px",
    height: isMobile ? "90px" : "100px",
    marginBottom: "0.5rem",
  };

  const editIconStyle = {
    position: "absolute",
    bottom: "5px",
    right: "5px",
    width: "30px",
    cursor: "pointer",
  };

  const rowStyle = {
    width: "100%",
    height: "40px",
    display: "flex",
    justifyContent: "left-start",
    alignItems: "center",
    marginBottom: "0.3rem",
    borderRadius: "8px",
    backgroundColor: theme.palette.mode === 'dark' ? "rgba(150,150,150,0.1)" : "rgba(0,0,0,0.05)",
    color: theme.palette.text.primary,
  };

  const labelStyle = {
    width: isMobile ? "20%" : "25%",
    height: "100%",
    display: "flex",
    justifyContent: "left-start",
    alignItems: "center",
    fontSize: "12px",
    padding: "8px 20px",
    marginRight: "0.5rem",
    backgroundImage: `linear-gradient(to top right, ${theme.palette.background.default}, ${theme.palette.background.paper})`,
    color: theme.palette.primary.main,
    borderTopLeftRadius: "8px",
    borderBottomLeftRadius: "8px",
  };
  const valueStyle = {
    padding: "7px",
    fontSize: "12px",
    marginRight: "0.5rem",
    textAlign: "left",
    fontWeight: 400,
    whiteSpace: "nowrap", // Prevents text from wrapping to the next line
    overflow: "hidden", // Hides the overflowing text
    textOverflow: "ellipsis",
  };

  const changeStyle = {
    width: "100%",
    textAlign: "right",
    fontSize: "11px",
    marginBottom: "20px"
  };

  // const handleTextClick = text => {
  //     navigator.clipboard
  //         .writeText(text)
  //         .then(() => {})
  //         .catch(err => {
  //             console.error('Unable to copy text to clipboard:', err);
  //         });
  // };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  // password change
  // const handleChangePassword = () => {
  //     setIsEditingPassword(true);
  // };
  // const handleCancelChangePassword = () => {
  //     setIsEditingPassword(false);
  // };

  // const handleUpdateProfile = () => {
  //     setIsEditingPassword(false);

  // change password
  const handleClickOpen = (event) => {
    event.preventDefault();
    setOpen(true);
  };
  const handleClickEmailOpen = (event) => {
    event.preventDefault();
    setEmailOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      setOtpSent(false);
      setOtpVerified(false);
      setSnackbarMessage("");
      setNewPassword("");
      setConfirmPassword("");
      setErrorMsgForgotPwd("");
    }, 1000);
  };
  const handleEmailClose = () => {
    setEmailOpen(false);
    setTimeout(() => {
      setSnackbarMessage("");
      setNewEmailValue("");
    }, 1000);
  };

  // forgot password OTP
  const handleSendOTP = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/users/sendOtp?email=${email}`
      );
      if (response.status === 200) {
        setOtpSent(true);
        setSnackbarMessage(response?.data);
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          setSnackbarMessage("");
          handleSuccessClose();
        }, 2000);
      } else {
        // console.error('Unexpected status code:', response.status);
        setSnackbarMessage(response?.data);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      // console.error('Error sending OTP:', error);
      setSnackbarMessage("Error sending OTP");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setErrorMsgForgotPwd(error?.response?.data?.developermsg);
    }
  };

  const handleEmailChange = (e) => {
    setNewEmailValue((preveOtp) => (preveOtp = e.target.value.trim()));
  };

  const handleOpenEmailConfirm = () => {
    if (!newEmailValue) {
      setSnackbarMessage("Please enter valid email");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } else if (!/^[a-z]/.test(newEmailValue)) {
      setSnackbarMessage("Email should start with alphabet only");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    } else {
      const emailPattern = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
      const validEmail = emailPattern.test(newEmailValue);
      if (!validEmail) {
        setSnackbarMessage("Please enter valid email");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }
      setEmailConfirmOpen(true);
    }
  };
  const handleCloseEmailConfirm = () => {
    setEmailConfirmOpen(false);
  };

  const handleResetEmail = async () => {
    if (!newEmailValue) {
      setSnackbarMessage("Please enter New email");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } else {
      await axios
        .put(`${baseUrl}/users/updateEmail/${userId}/${newEmailValue}`)
        .then((response) => {
          if (response.status === 200) {
            setNewEmailValue("");
            setSnackbarMessage("Email changed successfully!");
            setSnackbarOpen(true);
            setTimeout(() => {
              handleSuccessClose();
              handleEmailClose();
              setEmailConfirmOpen(false);
              handleOkLogout();
            }, 2000);
          }
        })
        .catch((error) => {
          setSnackbarMessage(error?.response?.data);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        });
    }
  };

  const handleOtpChange = (e) => {
    const inputValue = e.target.value.trim();
    const numericValue = inputValue.replace(/\D/g, "");
    setOtpValue(numericValue);
  };

  const handleResendOTP = () => {
    // Resend OTP logic goes here
  };

  // set password to forgot password
  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value.trim());
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value.trim());
  };

  // clear error in forgot password screen
  const handlePwdErrorClear = () => {
    setErrorMsgForgotPwd((prevValue) => (prevValue = ""));
  };
  // verify otp
  const handleVerifyOTP = async () => {
    if (!otpValue) {
      setSnackbarMessage("Please enter valid OTP");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } else {
      try {
        const response = await axios.post(`${baseUrl}/users/verifyOtp`, {
          email: email,
          otp: otpValue,
        });
        if (response.status === 200) {
          setOtpValue("");
          setOtpVerified(true);
          setSnackbarMessage(response?.data);
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          setTimeout(() => {
            setSnackbarMessage("");
            handleSuccessClose();
          }, 2000);
        } else {
          setSnackbarMessage("Unexpected status code");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        setSnackbarMessage(error?.response?.data?.developermsg);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    }
  };

  // submit forgot password
  const handleResetPassword = async () => {
    const passwordPattern = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*/;

    if (!newPassword) {
      setSnackbarMessage("Please enter new password");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } else if (!confirmPassword) {
      setSnackbarMessage("Please enter confirm password");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } else if (newPassword !== confirmPassword) {
      setSnackbarMessage("Password and conform password are not same");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } else if (newPassword?.length < 8 || newPassword?.length > 15) {
      setSnackbarMessage("Password length must be between 8 and 15 characters");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } else if (!passwordPattern.test(newPassword)) {
      setSnackbarMessage(
        "Password must contain at least 1 lowercase letter, 1 uppercase letter and 1 digit"
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } else {
      await axios
        .put(`${baseUrl}/users/forgotpassword`, {
          email: email,
          password: newPassword,
        })
        .then((response) => {
          if (response.status === 200) {
            setNewPassword("");
            setSnackbarMessage(response?.data);
            setSnackbarSeverity("success");
            setSnackbarOpen(true);

            setTimeout(() => {
              handleSuccessClose();
              handleClose();
            }, 2000);
            dispatch(fetchAdminDetails(userId));
          }
        })
        .catch((error) => {
          setSnackbarMessage(error?.response?.data?.developermsg);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        });
    }
  };

  // close forgot password success popup
  const handleSuccessClose = () => {
    setSnackbarOpen(false);
  };

  const handleErrorClear = () => {
    setErrorMsgForgotPwd((prevValue) => (prevValue = ""));
  };

  // logout
  const handleOpen1 = () => {
    setLogoutOpen(true);
  };

  const handleClose1 = () => {
    setLogoutOpen(false);
  };

  const handleOkLogout = () => {
    handleClose1();
    sessionStorage.clear();
    localStorage.clear();
    dispatch(loginStatus(false));
    // const logoutUrl = 'https://login-stg.pwc.com/openam/UI/Logout/';
    // window.open(logoutUrl, '_self');
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  const handleProfileChangeClick = () => {
    setChangeMode(true);
  };
  const handleProfileRemoveClick = () => {
    setRemoveMode(true);
  };
  const handleProfileRemoveClickCancel = () => {
    setRemoveMode(false);
  };
  const handleProfileChangeClickCancel = () => {
    setChangeMode(false);
  };

  const handleRemoveProfilePic = async () => {
    try {
      const response = await fetch(`${baseUrl}/users/deleteProfilePic/${userId}`, {
        method: 'DELETE',
      });

      if (response?.status === 200) {
        setSnackbarMessage('Profile picture deleted successfully!');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setProfilePicture(null);
        setEditMode(false);
        setRemoveMode(false);
      } else {
        console.error('Unexpected status code:', response?.status);
      }
    } catch (error) {
      setSnackbarMessage(error?.response?.data?.developermsg);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
    fetchProfilePicture(userId);
    setRemoveMode(false);
  };

  return (
    <Box>
      {/* Mobile Top Header (only visible on mobile) */}
      {isMobile && (
        <Box
          sx={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            position: "fixed", height: "60px", top: 0, right: 0, left: 0, px: 2,
            background: theme.palette.mode === 'dark' ? "rgba(10, 10, 10, 0.8)" : "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(12px)", borderBottom: `1px solid ${theme.palette.divider}`, zIndex: 1100,
          }}
        >
          <img
            src={trendAdsLogo}
            alt="Trend ads logo"
            style={{ height: "30px", cursor: "pointer" }}
            onClick={() => navigate("dashboard")}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ThemeToggle />
            <Badge badgeContent={displayNotificationCount} color="primary">
              <IconButton onClick={toggleNotificationPopup} size="small">
                <img src={BellIcon} alt="Notifications" style={{ height: "20px", filter: theme.palette.mode === 'light' ? 'invert(1)' : 'invert(0)' }} />
              </IconButton>
            </Badge>
            <IconButton onClick={() => setIsSidebarOpen(true)} size="small" sx={{ ml: 1 }}>
              <MenuIcon sx={{ color: 'text.primary' }} />
            </IconButton>
          </Box>

          {isNotificationOpen && (
            <Box ref={notificationBoxRef} sx={{
              position: "absolute", top: "65px", right: "10px", zIndex: 1101,
              backgroundColor: "background.paper", borderRadius: "12px", boxShadow: theme.shadows[10],
              width: "300px", border: `1px solid ${theme.palette.divider}`,
            }}
            >
              <Notifications />
            </Box>
          )}
        </Box>
      )}

      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        sx={{
          "& .MuiDrawer-paper": { width: "280px", border: "none", backgroundColor: "transparent" },
          display: { xs: "block", sm: "none" }
        }}
        ModalProps={{ keepMounted: true }}
      >
        <SidebarContent isMobileDrawer={true} />
      </Drawer>

      {/* Desktop Sidebar (Permanent) */}
      {!isMobile && (
        <Box sx={{ width: isCollapsed ? "80px" : "280px", transition: 'width 0.3s ease' }}>
          <SidebarContent />
        </Box>
      )}

      {/* profile drawer */}
      <Drawer
        anchor="left"
        onClose={handleCloseNav}
        style={{
          width: "100vw",
          zIndex: 1301,
        }}
        PaperProps={{
          style: {
            backgroundImage: theme.palette.mode === 'dark'
              ? "linear-gradient(to top right, #0a0b2a, #1b6a88)"
              : "linear-gradient(to top right, #ffffff, #f0f4f8)",
          },
        }}
      >
        <Box
          style={{
            width: "100vw",
            height: "100vh",
            position: "relative",
            color: theme.palette.text.primary,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IconButton
            style={{
              position: "absolute",
              top: 20,
              left: isMobile ? 10 : 45,
              fontSize: 60,
              color: theme.palette.text.primary,
            }}
            onClick={handleCloseNav}
          >
            <ArrowBackOutlinedIcon />{" "}
            <Typography sx={{ fontSize: "14px", marginLeft: "10px" }}>
              {" "}
              Back
            </Typography>
          </IconButton>
          <Box
            style={profileContainerStyle}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {profilePicture ? (
                <img
                  src={profilePicture}
                  alt="Profile"
                  style={{
                    width: "120px",
                    height: "120px",
                    border: `2px solid ${theme.palette.text.primary}`,
                    borderRadius: "50%",
                  }}
                />
              ) : (
                <Avatar
                  alt="Profile Image"
                  src={ProfileImage}
                  style={avatarStyle}
                />
              )}
              {editMode && !changeMode && (
                <Box
                  sx={{
                    border: "1px solid grey",
                    padding: { xs: "5px 10px", md: "5px 20px" },
                    borderRadius: "8px",
                    marginBottom: "16px",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: { xs: "center", sm: "space-between" },
                  }}
                >
                  <Button
                    onClick={handleProfileChangeClick}
                    sx={{
                      textTransform: "none",
                      fontSize: "12px",
                      color: theme.palette.common.black,
                      padding: {
                        xs: "2px 20px",
                        sm: "8px 20px",
                        md: "4px 20px",
                      },
                      fontWeight: 600,
                      borderRadius: "8px",
                      marginLeft: isMobile ? "5px" : "10px",
                      marginTop: isMobile ? "5px" : "0px",
                      backgroundColor: theme.palette.mode === 'dark' ? "rgba(150, 150, 150, 0.1)" : "rgba(0, 0, 0, 0.05)",
                      "&:hover": {
                        backgroundColor: theme.palette.mode === 'dark' ? "rgba(150, 150, 150, 0.15)" : "rgba(0, 0, 0, 0.08)",
                      },
                    }}
                  >
                    Change profile picture
                  </Button>
                  {profilePicture !== null && (
                    <Button
                      onClick={handleProfileRemoveClick}
                      sx={{
                        textDecoration: "none",
                        border: `1px solid ${theme.palette.text.primary}`,
                        fontSize: "12px",
                        color: theme.palette.primary.main,
                        textTransform: "none",
                        padding: "2px 20px",
                        marginLeft: { xs: "5px", md: "10px" },
                        "&:hover": {
                          backgroundColor: theme.palette.mode === 'dark' ? 'rgba(150,150,150,0.1)' : 'rgba(0,0,0,0.05)'
                        },
                      }}
                    >
                      Remove profile picture
                    </Button>
                  )}
                  <Button
                    onClick={handleProfileEditClickCancel}
                    sx={{
                      textDecoration: "none",
                      fontSize: "12px",
                      color: theme.palette.primary.main,
                      textTransform: "none",
                      padding: "2px 20px",
                      marginLeft: { xs: "5px", md: "10px" },
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              )}
              {editMode && changeMode && (
                <Box
                  sx={{
                    border: "1px solid grey",
                    padding: { xs: "5px 10px", md: "5px 20px" },
                    borderRadius: "8px",
                    marginBottom: "16px",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: { xs: "center", sm: "space-between" },
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                  <Box sx={{ marginTop: isMobile ? "10px" : "0px" }}>
                    <Button
                      onClick={handleImageUpload}
                      sx={{
                        textTransform: "none",
                        fontSize: "12px",
                        color: theme.palette.common.black,
                        padding: {
                          xs: "2px 20px",
                          sm: "8px 20px",
                          md: "4px 20px",
                        },
                        fontWeight: 600,
                        borderRadius: "8px",
                        marginLeft: isMobile ? "5px" : "10px",
                        border: `1px solid ${theme.palette.divider}`,
                        backgroundColor: "transparent",
                        "&:hover": {
                          backgroundColor: theme.palette.mode === 'dark' ? "rgba(150, 150, 150, 0.1)" : "rgba(0, 0, 0, 0.05)",
                        },
                      }}
                    >
                      Upload
                    </Button>
                    <Button
                      onClick={handleProfileChangeClickCancel}
                      sx={{
                        textDecoration: "none",
                        fontSize: "12px",
                        color: theme.palette.primary.main,
                        textTransform: "none",
                        padding: "2px 20px",
                        marginLeft: { xs: "5px", md: "10px" },
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              )}
              {!editMode && (
                <img
                  src={EditIcon}
                  style={editIconStyle}
                  onClick={handleProfileEditClick}
                  alt="Edit"
                />
              )}
            </div>
            <Typography variant="body1">{email}</Typography>
            <Typography
              variant="subtitle1"
              style={{
                marginBottom: "0.5rem",
                color: theme.palette.primary.main,
                textTransform: "uppercase",
              }}
            >
              {userRole}
            </Typography>
          </Box>
          <Grid container display="flex" justifyContent="center">
            <Grid item xs={11} sm={2} md={3} lg={3.5}></Grid>
            <Grid item xs={11} sm={8} md={6} lg={5}>
              <Box style={rowStyle}>
                <Typography style={labelStyle}>Email Address:</Typography>
                <Typography style={valueStyle}>{email}</Typography>
              </Box>
              <Typography style={changeStyle}
                onClick={handleClickEmailOpen}
                sx={{
                  cursor: "pointer",
                  display: "inline-block",
                  fontSize: "11px",
                  "&:hover": {
                    textDecoration: "underline",
                    color: theme.palette.primary.main,
                  },
                }}
              >
                Change Email

              </Typography>

              <Box style={rowStyle}>
                <Typography style={labelStyle}>Password:</Typography>
                <Box width="75%">
                  <Typography
                    variant="body1"
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr auto",
                      alignItems: "center",
                      fontSize: "12px",
                      paddingLeft: "7px",
                    }}
                  >
                    ●●●●●●●●
                  </Typography>
                </Box>
              </Box>
              <Typography style={changeStyle}
                onClick={handleClickOpen}
                sx={{
                  cursor: "pointer",
                  display: "inline-block",
                  fontSize: "11px",
                  "&:hover": {
                    textDecoration: "underline",
                    color: theme.palette.primary.main,
                  },
                }}
              >
                Change Password

              </Typography>
              {/* )} */}
            </Grid>
            <Grid item xs={11} sm={2} md={3} lg={3.5}></Grid>
          </Grid>

          {/* change email */}
          <Dialog
            maxWidth="xs"
            sx={{ zIndex: 1302 }}
            PaperProps={{
              style: {
                minWidth: "35vw",
                height: isMobile || isCollapsed ? "auto" : "80vh",
                backgroundImage: `linear-gradient(to top right, ${theme.palette.background.default}, ${theme.palette.background.paper})`,
                color: theme.palette.text.primary,
                borderRadius: "30px",
                padding: "30px",
              },
            }}
            open={emailOpen}
            onClose={handleEmailClose}
            onChange={handlePwdErrorClear}
          >
            <>
              <DialogTitle
                style={{
                  textAlign: "center",
                  color: theme.palette.text.primary,
                }}
              >
                Change Email
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  sx={{
                    fontSize: "12px",
                    textAlign: "center",
                    color: theme.palette.text.primary,

                    marginBottom: "20px",
                  }}
                >
                  Enter new email address to change.
                </DialogContentText>
                <Box
                  component="form"
                  noValidate
                  sx={{ mt: 0.5 }}
                  onChange={handleErrorClear}
                >
                  <InputLabel
                    sx={{
                      textAlign: "left",
                      fontSize: "13px",
                      color: theme.palette.text.primary,
                      paddingTop: "20px",
                    }}
                  >
                    New Email
                  </InputLabel>
                  <TextField
                    sx={{
                      width: "100%",
                      marginTop: "10px",
                      marginBottom: "15px",
                      borderRadius: "8px",
                      color: theme.palette.text.primary,
                      backgroundColor: "rgba(150,150,150,0.1)",
                      "& .MuiInputBase-input": {
                        color: theme.palette.text.primary,
                        fontSize: "15px",
                      },
                      "& .MuiFilledInput-root": {
                        height: "37px",
                        backgroundColor: "rgba(150,150,150,0.1)",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "&:hover fieldset": {
                          border: "none",
                        },
                        "&.Mui-focused fieldset": {
                          border: "none",
                        },
                      },
                    }}
                    required
                    autoComplete="off"
                    size="small"
                    autoFocus
                    type="text"
                    fullWidth
                    value={newEmailValue}
                    onChange={handleEmailChange}
                    margin="normal"
                  />
                </Box>
                <Button
                  size="small"
                  fullWidth
                  sx={{
                    textTransform: "none",
                    marginTop: "20px",
                    fontWeight: 600,
                    borderRadius: "8px",
                    padding: "7px",
                    color: theme.palette.primary.contrastText,
                    backgroundColor: theme.palette.primary.main,
                    "&:hover": {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  }}
                  variant="contained"
                  onClick={handleOpenEmailConfirm}
                >
                  Change Email
                </Button>

                <Typography
                  variant="body2"
                  style={{
                    marginTop: "30px",
                    textAlign: "center",
                    margin: "10px auto",
                  }}
                >
                  <Button
                    onClick={handleEmailClose}
                    sx={{
                      textDecoration: "none",
                      textTransform: "none",
                      padding: "5px 40px",
                      color: theme.palette.primary.main,
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                </Typography>
              </DialogContent>
            </>
          </Dialog>

          {/* change password  dialog*/}
          <Dialog
            maxWidth="xs"
            sx={{ zIndex: 1302 }}
            PaperProps={{
              style: {
                height: isMobile || isCollapsed ? "auto" : "80vh",
                width: isLargeScreen ? "40vw" : "",
                backgroundImage: `linear-gradient(to top right, ${theme.palette.background.default}, ${theme.palette.background.paper})`,
                color: theme.palette.text.primary,
                borderRadius: "30px",
                padding: "30px",
              },
            }}
            open={open}
            onClose={handleClose}
            onChange={handlePwdErrorClear}
          >
            {!otpSent && (
              <>
                <DialogTitle
                  style={{
                    textAlign: "center",
                    color: theme.palette.text.primary,
                  }}
                >
                  Change Password
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    sx={{
                      fontSize: "12px",
                      textAlign: "center",
                      color: theme.palette.text.primary,
                      padding: "0px 30px",
                      marginBottom: "20px",
                    }}
                  >
                    Code will be sent to below email address to change your
                    Password.
                  </DialogContentText>
                  <Box
                    component="form"
                    noValidate
                    sx={{ mt: 0.5 }}
                    onChange={handleErrorClear}
                  >
                    <InputLabel
                      sx={{
                        textAlign: "left",
                        fontSize: "13px",
                        color: theme.palette.text.primary,
                        paddingTop: "20px",
                      }}
                    >
                      Email
                    </InputLabel>
                    <Typography
                      variant="body2"
                      sx={{
                        padding: "10px",
                        marginTop: "10px",
                        borderRadius: "8px",
                        backgroundColor: "rgba(150,150,150,0.2)",
                      }}
                    >
                      {email}
                    </Typography>
                  </Box>

                  {errorMsgForgotPwd && (
                    <Box mt="10px">
                      <Alert severity="error">{errorMsgForgotPwd}</Alert>
                    </Box>
                  )}

                  <Button
                    size="small"
                    fullWidth
                    sx={{
                      textTransform: "none",
                      marginTop: "20px",
                      fontWeight: 600,
                      padding: "7px",
                      borderRadius: "8px",
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                      "&:hover": {
                        backgroundColor: theme.palette.primary.dark,
                      },
                    }}
                    variant="contained"
                    onClick={handleSendOTP}
                  >
                    Get Code
                  </Button>

                  <Typography
                    variant="body2"
                    style={{
                      marginTop: "30px",
                      textAlign: "center",
                      margin: "10px auto",
                    }}
                  >
                    <Button
                      onClick={handleClose}
                      sx={{
                        textDecoration: "none",
                        textTransform: "none",
                        padding: "5px 40px",
                        borderRadius: "8px",
                        color: theme.palette.primary.main,
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                  </Typography>
                </DialogContent>
              </>
            )}
            {otpSent && !otpVerified && (
              <>
                <DialogTitle
                  style={{
                    textAlign: "center",
                    color: theme.palette.text.primary,
                  }}
                >
                  Change Password
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    sx={{
                      fontSize: "12px",
                      textAlign: "center",
                      color: theme.palette.text.primary,
                      padding: "0px 30px",
                      marginBottom: "20px",
                    }}
                  >
                    Enter the 6 digit Code we have sent you on your mail.
                  </DialogContentText>
                  <Box
                    component="form"
                    noValidate
                    sx={{ marginTop: "20px" }}
                    onChange={handleErrorClear}
                  >
                    <InputLabel
                      sx={{
                        textAlign: "left",
                        fontSize: "13px",
                        color: theme.palette.text.primary,
                      }}
                    >
                      Code
                    </InputLabel>
                    <TextField
                      sx={{
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "15px",
                        borderRadius: "8px",
                        color: theme.palette.text.primary,
                        "& .MuiInputBase-input": {
                          color: theme.palette.text.primary,
                          fontSize: "15px",
                        },
                        "& .MuiFilledInput-root": {
                          height: "37px",
                          backgroundColor: "rgba(150,150,150,0.1)",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "rgba(150,150,150,0.1)",
                          "& fieldset": {
                            border: "none",
                          },
                          "&:hover fieldset": {
                            border: "none",
                          },
                          "&.Mui-focused fieldset": {
                            border: "none",
                          },
                        },
                      }}
                      required
                      autoComplete="off"
                      size="small"
                      // variant="filled"
                      autoFocus
                      type="text"
                      fullWidth
                      value={otpValue}
                      onChange={handleOtpChange}
                      margin="normal"
                      inputProps={{ maxLength: 6 }}
                    />
                  </Box>

                  {errorMsgForgotPwd && (
                    <Box mt="10px">
                      <Alert severity="error">{errorMsgForgotPwd}</Alert>
                    </Box>
                  )}
                  <Button
                    size="small"
                    fullWidth
                    sx={{
                      textTransform: "none",
                      marginTop: "20px",
                      fontWeight: 600,
                      padding: "7px",
                      borderRadius: "8px",
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                      "&:hover": {
                        backgroundColor: theme.palette.primary.dark,
                      },
                    }}
                    variant="contained"
                    onClick={handleVerifyOTP}
                  >
                    Verify
                  </Button>
                  <Typography
                    variant="body2"
                    marginTop="20px"
                    marginLeft="2px"
                  >
                    Didn't receive the code?{" "}
                    <Button
                      sx={{
                        color: theme.palette.primary.main,
                        textTransform: "none",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                      onClick={handleSendOTP}
                    >
                      Resend code
                    </Button>
                  </Typography>
                </DialogContent>
              </>
            )}

            {otpSent && otpVerified && (
              <>
                <DialogTitle
                  style={{
                    textAlign: "center",
                    color: theme.palette.text.primary,
                  }}
                >
                  Change Password
                  <Typography variant="body2" textAlign="center">
                    Create new password
                  </Typography>
                </DialogTitle>
                <DialogContent>
                  <Box
                    component="form"
                    noValidate
                    sx={{ mt: 0.5 }}
                    onChange={handleErrorClear}
                  >
                    <InputLabel
                      sx={{
                        textAlign: "left",
                        fontSize: "13px",
                        color: theme.palette.text.primary,
                      }}
                    >
                      Set Password
                    </InputLabel>
                    <TextField
                      sx={{
                        width: "100%",

                        marginBottom: "15px",
                        borderRadius: "8px",
                        color: theme.palette.text.primary,
                        "& .MuiInputBase-input": {
                          color: theme.palette.text.primary,
                          fontSize: "13px",
                        },
                        "& .MuiFilledInput-root": {
                          height: "37px",
                          backgroundColor: "rgba(150,150,150,0.1)",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "rgba(150,150,150,0.1)",
                          "& fieldset": {
                            border: "none",
                          },
                          "&:hover fieldset": {
                            border: "none",
                          },
                          "&.Mui-focused fieldset": {
                            border: "none",
                          },
                        },
                      }}
                      required
                      autoComplete="off"
                      size="small"
                      // variant="filled"
                      autoFocus
                      margin="dense"
                      type={showPassword ? "text" : "password"}
                      fullWidth
                      id="newPassword"
                      value={newPassword}
                      onChange={handleNewPasswordChange}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleTogglePasswordVisibility}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOutlinedIcon
                                  sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: "20px",
                                  }}
                                />
                              ) : (
                                <VisibilityOffOutlinedIcon
                                  sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <InputLabel
                      sx={{
                        textAlign: "left",
                        fontSize: "13px",
                        color: theme.palette.text.primary,
                      }}
                    >
                      Confirm Password
                    </InputLabel>
                    <TextField
                      sx={{
                        width: "100%",
                        minWidth: "300px",
                        marginTop: "5px",
                        marginBottom: "15px",
                        borderRadius: "8px",
                        color: theme.palette.text.primary,
                        backgroundColor: "rgba(150,150,150,0.1)",
                        "& .MuiInputBase-input": {
                          color: theme.palette.text.primary,
                          fontSize: "13px",
                        },
                        "& .MuiFilledInput-root": {
                          height: "37px",
                          backgroundColor: "rgba(150,150,150,0.1)",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            border: "none", // Outlined border color
                          },
                          "&:hover fieldset": {
                            border: "none", // Hovered outlined border color
                          },
                          "&.Mui-focused fieldset": {
                            // borderColor:
                            //     'rgba(150,150,150,0.8)',
                            border: "none", // Focused outlined border color
                          },
                        },
                      }}
                      required
                      autoComplete="off"
                      size="small"
                      // variant="filled"

                      type={showConfirmPassword ? "text" : "password"}
                      fullWidth
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      margin="normal"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleToggleConfirmPasswordVisibility}
                              edge="end"
                            >
                              {showConfirmPassword ? (
                                <VisibilityOutlinedIcon
                                  sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: "20px",
                                  }}
                                />
                              ) : (
                                <VisibilityOffOutlinedIcon
                                  sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: "20px",
                                  }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>

                  {errorMsgForgotPwd && (
                    <Box mt="10px">
                      <Alert severity="error">{errorMsgForgotPwd}</Alert>
                    </Box>
                  )}
                  <Button
                    size="small"
                    fullWidth
                    sx={{
                      textTransform: "none",
                      marginTop: "15px",
                      borderRadius: "8px",
                      padding: "7px",
                      fontWeight: 600,
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                      "&:hover": {
                        backgroundColor: theme.palette.primary.dark,
                      },
                    }}
                    variant="contained"
                    onClick={handleResetPassword}
                  >
                    Reset
                  </Button>
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                    }}
                  >
                    <Typography
                      variant="body2"
                      fontSize="11px"
                      marginTop="10px"
                    >
                      Password must contain:
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        padding: "0px",
                      }}
                    >
                      <ul
                        style={{
                          fontSize: "10px",
                          paddingLeft: "10px",
                        }}
                      >
                        <li>1 lowercase letter</li>
                        <li>1 uppercase letter</li>
                        <li>1 digit (number)</li>
                      </ul>
                      <ul
                        style={{
                          fontSize: "10px",
                          paddingLeft: "0px",
                        }}
                      >
                        <li>Minimum 8 characters</li>
                        <li>Maximum 15 characters</li>
                      </ul>
                    </div>
                  </div>
                </DialogContent>
              </>
            )}
          </Dialog>
        </Box>
      </Drawer>

      <Modal
        open={logoutOpen}
        onClose={handleClose1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 1303 }}
      >
        <Box
          className="myStyle"
          sx={{ width: { xs: "90%", sm: "60%", md: "40vw" } }}
        >
          <Typography
            id="modal-modal-title"
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
            }}
            variant="body1"
            component="h2"
          >
            Are you sure to logout?
          </Typography>
          <Box
            style={{
              width: "70%",
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={(e) => handleOkLogout()}
              type="submit"
              sx={{
                width: "130px",
                height: "35px",
                backgroundColor: theme.palette.primary.main,
                borderRadius: "4px",
                textTransform: "none",
                fontWeight: 600,
                boxShadow: "none",
                marginRight: "30px",
                color: theme.palette.primary.contrastText,
                "&:hover": {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
            >
              Confirm
            </Button>{" "}
            <Button
              type="cancel"
              onClick={handleClose1}
              sx={{
                width: "130px",
                height: "35px",
                color: theme.palette.text.primary,
                backgroundColor: "transparent",
                border: `1px solid ${theme.palette.text.primary}`,
                borderRadius: "4px",
                fontWeight: 600,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(150,150,150,0.1)' : 'rgba(0,0,0,0.05)',
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={emailConfirmOpen}
        onClose={handleCloseEmailConfirm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 1303 }}
      >
        <Box
          className="myStyle"
          sx={{ width: { xs: "90%", sm: "60%", md: "40vw" } }}
        >
          <Typography
            id="modal-modal-title"
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
            }}
            variant="body1"
            component="h2"
          >
            Are you sure to change your email?
          </Typography>
          <Box
            style={{
              width: "70%",
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={(e) => handleResetEmail()}
              type="submit"
              sx={{
                width: "130px",
                height: "35px",
                backgroundColor: theme.palette.primary.main,
                borderRadius: "4px",
                textTransform: "none",
                fontWeight: 600,
                boxShadow: "none",
                marginRight: "30px",
                color: theme.palette.primary.contrastText,
                "&:hover": {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
            >
              Confirm
            </Button>{" "}
            <Button
              type="cancel"
              onClick={handleCloseEmailConfirm}
              sx={{
                width: "130px",
                height: "35px",
                color: theme.palette.text.primary,
                backgroundColor: "transparent",
                border: `1px solid ${theme.palette.text.primary}`,
                borderRadius: "4px",
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(150,150,150,0.1)' : 'rgba(0,0,0,0.05)',
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={removeMode}
        onClose={handleProfileRemoveClickCancel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        // sx={{zIndex: isMobile ? 1303: 0}}
        sx={{ zIndex: 1303 }}
      >
        <Box className='myStyle' sx={{ height: '200px', width: { xs: '90%', sm: '60%', md: '40vw' } }}>
          <Typography
            id="modal-modal-title"
            style={{
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center'
            }}
            variant="body1"
            component="h2"
          >
            Are you sure to remove profile picture?
          </Typography>
          <Box
            style={{
              width: '70%',
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20px'
            }}
          >
            <Button
              onClick={e => handleRemoveProfilePic()}
              type="submit"
              variant="contained"
              sx={{
                width: '130px',
                height: '35px',
                borderRadius: '8px',
                textTransform: 'none',
                boxShadow: 'none',
                fontWeight: 600,
                marginRight: '30px',
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
            >
              Confirm
            </Button>{' '}
            <Button
              type="cancel"
              onClick={handleProfileRemoveClickCancel}
              sx={{
                width: '130px',
                height: '35px',
                color: theme.palette.text.primary,
                backgroundColor: 'transparent',
                border: `1px solid ${theme.palette.text.primary}`,
                borderRadius: '8px',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(150,150,150,0.1)' : 'rgba(0,0,0,0.05)'
                }
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
      {snackbarOpen && (
        <Portal>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{ zIndex: 1400 }}
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
          >
            <Alert
              elevation={6}
              // variant="filled"
              onClose={handleCloseSnackbar}
              severity={snackbarSeverity}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Portal>
      )}
    </Box>
  );
};

export default Sidebar;
